import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import { useNavigate } from "react-router-dom";
import LeadsDataPage from "./LeadsDataPage";
import {
  setFromDate,
  setToDate,
  setAction,
  setSelectedMonth,
  setChartData,
  toggleViewGeneralReport,
  setMonthlyData,
} from "../../../state/reducers/leadReportSlice";

// Import chart.js date adapter
import "chartjs-adapter-date-fns"; // Required for time scale
import WeeklyReportChart from "./WeeklyReportChart";
import FreshToEnquiryChart from "./FreshToEnquiryChart";
import EnquiryToCustomerChart from "./EnquiryToCustomerChart";
import MonthlyLeadsChart from "./MonthlyLeadsChart";
import SourceConversionReport from "./SourceConversionReport ";
import LeadReportAdminChart from "./LeadReportAdminChart";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  TimeScale
);

const ReportsDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    fromDate,
    toDate,
    action,
    selectedMonth,
    chartData,
    viewGeneralReport,
    weeklyConversionsData,
    sourcesConversionData,
    freshToEnquiryData,
    enquiryToCustomerData,
    monthlyData,
  } = useSelector((state) => state.reports);

  const handleShowData = () => {
    navigate("/admin/data-table");
  };

  const generateMonthData = (month) => {
    const daysInMonth = new Date(2025, month, 0).getDate();
    const labels = [];
    const data = [];

    for (let day = 1; day <= daysInMonth; day++) {
      labels.push(`${day}-${month + 1}-2025`);
      data.push(Math.floor(Math.random() * 300));
    }

    return {
      labels,
      datasets: [
        {
          label: "Monthly Data",
          backgroundColor: "#60a5fa",
          data,
        },
      ],
    };
  };

  const handleGenerate = () => {
    if (fromDate && toDate) {
      const names = [
        "Vinni Shah Modani",
        "Valencia Dsouza",
        "Saloni Sanjay Chikhe",
        "Saif Usmani",
        "Kunal Deshmukh",
        "Dhaval Gawas",
        "Arpan Modani",
        "Aniket Soni",
        "Adarsh Dubey",
        "Aahana Dabbama",
      ];

      const createdLeads = names.map(() => Math.floor(Math.random() * 1000));
      const lostLeads = names.map(() => Math.floor(Math.random() * 500));
      const convertedLeads = names.map(() => Math.floor(Math.random() * 300));

      const data = {
        labels: names,
        datasets: [
          {
            label: "Total Created Leads",
            backgroundColor: "#60A5FA",
            data: createdLeads,
          },
          {
            label: "Total Lost Leads",
            backgroundColor: "#F87171",
            data: lostLeads,
          },
          {
            label: "Total Converted Leads",
            backgroundColor: "#86EFAC",
            data: convertedLeads,
          },
        ],
      };

      dispatch(setChartData(data));
    } else {
      alert("Please select a valid date range.");
    }
  };

  const handleActionChange = (event) => {
    dispatch(setAction(event.target.value));
    if (event.target.value === "generate") {
      handleGenerate();
    }
  };

  useEffect(() => {
    const monthIndex = new Date(
      Date.parse(`${selectedMonth} 1, 2025`)
    ).getMonth();
    dispatch(setMonthlyData(generateMonthData(monthIndex)));
  }, [selectedMonth, dispatch]);

  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  return (
    <div
      className={`flex-1 bg-white ${
        isSideBarOpen ? "ml-80" : "ml-20"
      } min-h-screen`}
    >
      <div className="p-6 bg-gray-100 min-h-screen space-y-6">
        <div className="flex justify-between items-center">
          <button
            onClick={() => dispatch(toggleViewGeneralReport())}
            className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600"
          >
            {viewGeneralReport
              ? "Switch to General Report "
              : "Switch to Staff Report"}
          </button>
        </div>

        {viewGeneralReport ? (
          // <div className="container mx-auto p-6">
          //   <div className="flex justify-between items-center mb-6">
          //     <div className="flex space-x-4">
          //       <div className="flex items-center space-x-2">
          //         <label htmlFor="from-date" className="text-lg font-medium">
          //           From date:
          //         </label>
          //         <input
          //           id="from-date"
          //           type="date"
          //           value={fromDate}
          //           onChange={(e) => dispatch(setFromDate(e.target.value))}
          //           className="border border-gray-300 rounded-lg p-2"
          //         />
          //       </div>
          //       <div className="flex items-center space-x-2">
          //         <label htmlFor="to-date" className="text-lg font-medium">
          //           To date:
          //         </label>
          //         <input
          //           id="to-date"
          //           type="date"
          //           value={toDate}
          //           onChange={(e) => dispatch(setToDate(e.target.value))}
          //           className="border border-gray-300 rounded-lg p-2"
          //         />
          //       </div>
          //     </div>
          //     <select
          //       onClick={handleActionChange}
          //       value={action}
          //       className="border p-2 rounded-md"
          //     >
          //       <option value="generate">Generate</option>
          //       <option value="list">List</option>
          //     </select>
          //   </div>

          //   {action === "generate" && chartData && (
          //     <div className="bg-white p-6 rounded-lg shadow-lg">
          //       <h2 className="text-xl font-bold mb-4">Lead Report</h2>
          //       <Bar
          //         data={chartData}
          //         options={{
          //           responsive: true,
          //           plugins: {
          //             legend: { position: "top" },
          //             tooltip: {
          //               callbacks: {
          //                 label: (context) =>
          //                   `${context.dataset.label}: ${context.raw}`,
          //               },
          //             },
          //           },
          //           scales: {
          //             x: { beginAtZero: true, ticks: { font: { size: 10 } } },
          //             y: { beginAtZero: true },
          //           },
          //         }}
          //       />
          //     </div>
          //   )}

          //   {action === "list" && (
          //     <div className="w-full">
          //       <LeadsDataPage />
          //     </div>
          //   )}
          // </div>
          <LeadReportAdminChart/>
        ) : (
          // Staff Report View
          <div className="space-y-4">
            <h2 className="text-2xl font-bold mb-4">Staff Report</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <div className="bg-white p-6 rounded shadow-lg">
                <div className="flex justify-between">
                  <h2 className="text-lg font-bold mb-4">
                    This Week Leads Conversions
                  </h2>
                  <button
                    onClick={handleShowData}
                    className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                  >
                    Show Data
                  </button>
                </div>
                <Bar
                  data={weeklyConversionsData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              </div> */}
<WeeklyReportChart/>

              {/* <div className="bg-white p-6 rounded shadow-lg">
                <div className="flex justify-between">
                  <h2 className="text-lg font-bold mb-4">Sources Conversion</h2>
                  <button
                    onClick={handleShowData}
                    className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                  >
                    Show Data
                  </button>
                </div>
                <Bar
                  data={sourcesConversionData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              </div> */}
              <SourceConversionReport/>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <div className="bg-white p-6 rounded shadow-lg">
                <div className="flex justify-between">
                  <h2 className="text-lg font-bold mb-4">
                    Fresh Lead to Enquiry Lead
                  </h2>
                  <button
                    onClick={handleShowData}
                    className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                  >
                    Show Data
                  </button>
                </div>
                <Bar
                  data={freshToEnquiryData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              </div>

              <div className="bg-white p-6 rounded shadow-lg">
                <div className="flex justify-between">
                  <h2 className="text-lg font-bold mb-4">
                    Enquiry Lead to Customer
                  </h2>
                  <button
                    onClick={handleShowData}
                    className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                  >
                    Show Data
                  </button>
                </div>
                <Bar
                  data={enquiryToCustomerData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              </div> */}
{/* <LeadConversionReport graphType="fresh_to_enquiry" />
<LeadConversionReport graphType="enquiry_to_customer" /> */}
<FreshToEnquiryChart/>
<EnquiryToCustomerChart/>
            </div>

            {/* <div className="bg-white p-6 rounded shadow-lg">
              <h2 className="text-lg font-bold mb-4">Monthly Report</h2>
              <div className="flex  justify-between ">
                <div className="flex items-center space-x-4 mb-4">
                  <label htmlFor="month-select" className="font-semibold">
                    Select Month
                  </label>
                  <select
                    id="month-select"
                    className="border border-gray-300 rounded px-4 py-2"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                  >
                    <option>January</option>
                    <option>February</option>
                    <option>March</option>
                    <option>April</option>
                    <option>May</option>
                    <option>June</option>
                    <option>July</option>
                    <option>August</option>
                    <option>September</option>
                    <option>October</option>
                    <option>November</option>
                    <option>December</option>
                  </select>
                </div>
                <button
                  onClick={handleShowData}
                  className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                >
                  Show Data
                </button>
              </div>

              <Line
                data={monthlyData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: true,
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                    },
                    x: {
                      type: "time",
                      time: {
                        unit: "day",
                        tooltipFormat: "ll",
                      },
                      title: {
                        display: true,
                        text: "Date",
                      },
                    },
                  },
                }}
              />
            </div> */}
            <MonthlyLeadsChart/>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportsDashboard;
